import { render, staticRenderFns } from "./EstimatedSales.vue?vue&type=template&id=99687aa0"
import script from "./EstimatedSales.vue?vue&type=script&lang=js"
export * from "./EstimatedSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports